import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import LandingPage from './components/app/public/LandingPage/LandingPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage/>}></Route>
        <Route path="/home" element={<LandingPage/>}></Route>
        <Route path="/download" element={<LandingPage/>}></Route>
        <Route
            path="*"
            element={<Navigate to="/" replace/>}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
